<template>
  <footer class="it-footer">
    <div class="it-footer-main" style="background-color: #002677;">
      <!-- Upper Section-->
      <div class="it-footer-top col-12 d-flex justify-content-center flex-wrap flex-row container py-3 ps-3">
        <div class="row justify-content-between align-items-center">
          <div class="col-12 d-flex flex-column flex-lg-row justify-content-start align-items-start">
            <div class="d-flex flex-column align-items-start mb-3 mb-lg-0">
              <img src="@/assets/logo_orizzontale_WHITE.png" alt="Università di Genova Logo"
                   class="unige-logo-footer mb-3 mb-lg-0"/>
            </div>
            <div
                class="footer-links d-flex flex-column align-items-start text-left flex-lg-row text-lg-start align-items-lg-start">
              <span class="vertical-divider d-none d-xl-inline-block mx-lg-3"></span>
              <a href="https://unige.it/trasparenza" class="footer-link text-white mb-2 mb-lg-0 mx-lg-3">{{ $t('transparentAdministration') }}</a>
              <span class="vertical-divider d-none d-xl-inline-block mx-lg-3"></span>
              <a href="https://unige.it/trasparenza/accesso_civico/accesso_civico_generalizzato.html"
                 class="footer-link text-white mb-2 mb-lg-0 mx-lg-3">{{ $t('generalAccess') }}</a>
              <span class="vertical-divider d-none d-xl-inline-block mx-lg-3"></span>
              <a href="https://unige.it/albo/" class="footer-link text-white mb-2 mb-lg-0 mx-lg-3">Albo online</a>
              <span class="vertical-divider d-none d-xl-inline-block mx-lg-3"></span>
              <a href="https://unige.it/ateneo/atti_notifica" class="footer-link text-white mb-2 mb-lg-0 mx-lg-3">{{ $t('notificationActs') }}</a>
              <span class="vertical-divider d-none d-xl-inline-block mx-lg-3"></span>
              <a href="https://unige.it/elenco-siti-tematici" class="footer-link text-white mb-2 mb-lg-0 mx-lg-3">{{ $t('thematicWebsites') }}</a>
              <span class="vertical-divider d-none d-xl-inline-block mx-lg-3"></span>
              <a href="https://info.unige.it/otrs/public.pl" class="footer-link text-white mb-2 mb-lg-0 mx-lg-3">URP</a>
              <span class="vertical-divider d-none d-xl-inline-block mx-lg-3"></span>
              <a href="https://unige.it/unige/servizi#servizi-per-tutti-text"
                 class="footer-link text-white mb-2 mb-lg-0 mx-lg-3">PagoPA</a>
              <span class="vertical-divider d-none d-xl-inline-block mx-lg-3"></span>
              <a href="https://unige.it/contatti" class="footer-link text-white mb-2 mb-lg-0 mx-lg-3">{{ $t('contacts') }}</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Social Media Icons Section -->
      <div class="container social-icons-container"> <!-- Wrap in a container to align with the upper section -->
        <div class="row">
          <div class="col-12 d-flex justify-content-center flex-wrap social-icons-wrapper"> <!-- Default alignment -->
            <a href="https://www.linkedin.com/school/universit-degli-studi-di-genova/" class="mx-2"><i
                class="fab fa-linkedin"></i></a>
            <a href="#" class="mx-2"><i class="fab fa-twitter"></i></a>
            <a href="https://www.youtube.com/channel/UCUzI7864bUoJgke195EznOg" class="mx-2"><i
                class="fab fa-youtube"></i></a>
            <a href="https://www.instagram.com/unigenova/" class="mx-2"><i class="fab fa-instagram"></i></a>
            <a href="https://www.facebook.com/Unigenova/" class="mx-2"><i class="fab fa-facebook"></i></a>
            <a href="#" class="mx-2"><i class="fab fa-tiktok"></i></a>
            <a href="https://t.me/UniGenova_official" class="mx-2"><i class="fab fa-telegram"></i></a>
          </div>
        </div>
      </div>
    </div>

    <!-- Middle Section-->
    <div class="footer-middle container-fluid py-4" style="background-color: #171437;">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-12 text-white">
            <p class="mb-0">Università degli Studi di Genova <br> Via Balbi 5, 16126 Genova</p>
          </div>
          <div class="col-lg-3 col-12 text-white">
            <p class="mb-0">tel +39 01020991 <br> fax +39 0102099227</p>
          </div>
          <div class="col-lg-3 col-12 text-white">
            <p class="mb-0">protocollo@<br>pec.unige.it</p>
          </div>
          <div class="col-lg-3 col-12 text-white">
            <p class="mb-0">Partita IVA <br>00754150100</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Section-->
    <div class="footer-bottom py-4" style="background-color: #000000;">
      <div class="container">
        <div class="d-flex justify-content-center align-items-center footer-items-wrapper flex-wrap">
          <div class="footer-item text-white text-center mx-2">
            <p class="mb-0">© copyright and credits</p>
          </div>
          <div class="divider mx-2"></div>
          <div class="footer-item text-white text-center mx-2">
            <a href="https://unige.it/privacy/cookie" class="text-white no-underline">
              <p class="mb-0">cookie policy</p>
            </a>
          </div>
          <div class="divider mx-2"></div>
          <div class="footer-item text-white text-center mx-2">
            <a href="https://unige.it/privacy" class="text-white no-underline">
              <p class="mb-0">privacy</p>
            </a>
          </div>
          <div class="divider mx-2"></div>
          <div class="footer-item text-white text-center mx-2">
            <a href="https://unige.it/accessibilita" class="text-white no-underline">
              <p class="mb-0">dichiarazione di accessibilità</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
</script>

<style scoped>
.footer-links a {
  color: white;
  font-size: 14px;
  text-decoration: none;
  font-family: 'Open Sans', sans-serif;
}

.unige-logo-footer {
  height: 50px;
  max-height: 100%;
  display: block;
}

.vertical-divider {
  width: 1px;
  height: 40px;
  background-color: white;
}

.social-icons i {
  color: white;
  font-size: 18px;
  text-align: center;
  justify-content: space-between;
}

.social-icons a:hover i {
  color: #ccc;
}

.footer-bottom {
  background-color: #1a1a1a;
}

.footer-bottom a {
  color: white;
  font-size: 14px;
  text-decoration: none;
}

.footer-bottom a:hover {
  text-decoration: none;
}

.footer-item {
  display: inline-block;
  margin-right: 20px;
  text-align: center;
}

.footer-item p {
  margin: 0;
}

.it-footer-top {
  text-align: center !important;
  align-items: center !important;
  justify-content: center !important;
}

.footer-middle .row > div {
  padding-left: 0;
  padding-right: 0;
}

.footer-bottom .footer-items-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
}

.footer-bottom .footer-item {
  text-align: center;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.footer-bottom a {
  color: white;
  text-decoration: none;
}

.footer-bottom a:hover {
  text-decoration: underline;
}

.divider {
  width: 1px;
  height: 20px;
  background-color: white;
}

.footer-bottom .d-flex {
  justify-content: center;
  align-items: center;
}

@media (max-width: 1200px) {
  .it-footer-top .d-flex {
    flex-direction: column !important;
    align-items: flex-start !important;
    text-align: left !important;
  }

  .social-icons-container .social-icons-wrapper {
    justify-content: flex-start !important;
    padding-left: 0;
  }

  .social-icons-container {
    text-align: left;
  }

  .footer-links {
    text-align: left !important;
    align-items: flex-start !important;
  }

  .footer-links a {
    margin-bottom: 10px;
  }

  .col-12 {
    text-align: left !important;
  }

  .flex-row {
    justify-content: flex-start !important;
  }
}

@media (max-width: 1200px) {
  .footer-middle .row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-middle .col-12 {
    width: 100%;
    margin-bottom: 15px;
  }

  .footer-middle .col-12 p {
    margin: 0;
  }
}

@media (min-width: 1200px) {
  .footer-middle .row {
    display: flex;
    justify-content: space-between;
    align-items: start;
  }

  .footer-middle .col-lg-3 {
    text-align: left;
  }
}

@media (max-width: 992px) {
  .it-footer-main .d-flex {
    align-items: flex-start !important;
    text-align: left !important;
  }

  .footer-links {
    align-items: flex-start !important;
  }

  .footer-middle .row {
    text-align: center;
  }

  .footer-bottom .footer-items-wrapper {
    justify-content: space-between;
    padding: 0 10px;
    gap: 10px;
  }

  .footer-bottom .footer-item {
    flex: 1;
    font-size: 0.75rem;
    min-width: 0;
  }

  .footer-bottom .footer-item p {
    margin: 0;
    white-space: nowrap;
  }

  .divider {
    display: none;
  }
}

@media (max-width: 768px) {

  .footer-bottom .footer-items-wrapper {
    padding: 0 5px; /* Reduce padding */
  }

  .footer-bottom .footer-item:nth-child(1) p {
    display: none;
  }

  .footer-bottom .footer-item:nth-child(1)::before {
    content: "© copyright \a and credits";
    white-space: pre-wrap;
    text-align: center;
    display: block;
  }

  .footer-bottom .footer-item:last-child p {
    display: none;
  }

  .footer-bottom .footer-item:last-child::before {
    content: "dichiarazione di \a accessibilità";
    white-space: pre-wrap;
    text-align: center;
    display: block;
  }
}

</style>
